import { useState, useEffect } from "react";
import boltSvg from "@/assets/bolt.svg";
import { useSoundEffects } from "@/hooks/useSoundEffects";
import posthog from "posthog-js";
import { Button } from "../ui/button";

export function BonusScratchesModal({ show, bonusScratches, onClick }: { show: boolean, bonusScratches: number | null, onClick?: () => void }) {
    const [isVisible, setIsVisible] = useState(false);
    const [soundEffect, ] = useState<"bonus1">("bonus1");
    const playSoundEffect = useSoundEffects();
  
    useEffect(() => {
      if (bonusScratches && show) {
        playSoundEffect?.(soundEffect);
        posthog.capture("bonusScratchesActivated", {
          bonusScratches,
        });

        // Small delay to ensure transition starts properly
        const timer = setTimeout(() => setIsVisible(true), 50);
        return () => clearTimeout(timer);
      }
        setIsVisible(false);
    }, [bonusScratches, soundEffect, playSoundEffect, show]);
  
    if (!show) return null;
  
    return (
      <div className="fixed inset-0 flex items-center justify-center">
        {/* Backdrop with fade in */}
        <div className={`absolute inset-0 bg-black transition-opacity duration-300 ${isVisible ? 'opacity-50' : 'opacity-0'}`} />
        
        {/* Modal container with pop animation */}
        <div className={`relative bg-white rounded-md p-3 pt-10 w-80 flex flex-col items-center space-y-6 transform transition-all duration-300 ease-out origin-center
          ${isVisible ? 'scale-100 opacity-100 translate-y-0' : 'scale-50 opacity-0 translate-y-4'}
        `}>

          {/* Bonus number with bounce animation */}
          <div className="text-center space-y-2">
            <div className="flex items-center justify-center gap-3">
              <span className="text-5xl font-bold bg-green text-white rounded-md px-4 py-1 transform transition-transform hover:scale-110 duration-200">
                {bonusScratches}
              </span>
              <span className="text-5xl text-green text-slate-800 font-bold">
                bonus
              </span>
            </div>
            <div className="text-5xl text-green text-slate-800 font-bold">
              {(bonusScratches && bonusScratches > 1) ? 'scratches' : 'scratch'}
            </div>
          </div>
  
          {/* Button with hover effect and pulse */}
          <Button 
            type="button" 
            onClick={onClick}
            className="w-[95%] bg-green text-white text-4xl font-semibold py-10 rounded-md flex items-center justify-center gap-3 transform transition-all duration-200 hover:scale-105 hover:brightness-110 active:scale-95 border-none"
          >
            <img 
              className={"h-8 animate-pulse-medium"} 
              src={boltSvg}
              alt="lightning bolt"
            />
            <span className={"animate-pulse-medium"}>
              Activate
            </span>
          </Button>
  
          {/* Glow effect */}
          {/* <div className="absolute -inset-1 bg-gradient-to-r from-green-1 via-green-2 to-green-1 opacity-25 blur-xl rounded-3xl -z-10" /> */}
        </div>
      </div>
    );
}